import { produce } from "immer";
import * as dlistsActions from "./dlistsActions";

const initialState = {
  isLoading: true,
  errorMessage: null,
  modalErrorMessage: null,
  deleteMembers: null,
  memberModal: null,
  memberItem: null,
  isModalLoading: false,
  members: {
    selected: {
      byId: {},
      allIds: []
    },
    hasMore: null,
    params: {},
    byId: {},
    allIds: []
  },
  hasMore: null,
  params: {},
  byId: {},
  allIds: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case dlistsActions.FETCH_DLISTS_PENDING: {
      draft.isLoading = true;
      draft.errorMessage = null;
      break;
    }

    case dlistsActions.FETCH_DLISTS_SUCCESS: {
      draft.isLoading = false;
      const allIds = action.payload.dlists.map(item => item.dlist);
      const byId = action.payload.dlists.reduce((obj, item) => {
        obj[item.dlist] = {
          ...item,
          value: item.dlist
        };

        return obj;
      }, {});

      draft.byId = byId;
      draft.allIds = allIds;
      draft.params = action.payload.params;
      draft.hasMore = action.payload.hasMore;

      break;
    }

    case dlistsActions.FETCH_DLISTS_FAILED: {
      draft.isLoading = false;
      draft.errorMessage = action.payload;
      break;
    }

    case dlistsActions.FETCH_DLISTS_MEMBERS_SUCCESS: {
      draft.isLoading = false;
      const allIds = action.payload.members.map(item => item.member);
      const byId = action.payload.members.reduce((obj, item) => {
        obj[item.member] = {
          ...item,
          value: item.member
        };

        return obj;
      }, {});

      const user = JSON.parse(localStorage.getItem("user"));

      delete byId[user.email];

      draft.members.byId = byId;
      draft.members.allIds = allIds;
      draft.members.params = action.payload.params;
      draft.hasMore = action.payload.hasMore;

      break;
    }

    case dlistsActions.DELETE_MEMBER: {
      draft.isModalLoading = true;
      break;
    }

    case dlistsActions.SET_DELETE_MEMBER_MODAL: {
      const { payload } = action;
      draft.deleteMembers = payload.deleteMembers;
      break;
    }

    case dlistsActions.DELETE_MEMBER_SUCCESS: {
      draft.isModalLoading = false;
      draft.deleteMembers = null;
      draft.members.selected.byId = {};
      draft.members.selected.allIds = [];
      break;
    }

    case dlistsActions.DELETE_MEMBER_FAILED: {
      draft.isModalLoading = false;
      draft.errorMessage = action.payload;
      break;
    }

    case dlistsActions.CLOSE_MEMBER_DELETE_MODAL: {
      draft.deleteMembers = null;
      break;
    }

    case dlistsActions.OPEN_MEMBER_MODAL: {
      draft.isModalLoading = false;
      draft.memberModal = !action.payload ? "add" : "edit";
      draft.memberItem = action.payload;
      break;
    }

    case dlistsActions.UPSERT_MEMBER: {
      draft.isModalLoading = true;
      draft.modalErrorMessage = null;
      break;
    }

    case dlistsActions.UPSERT_MEMBER_SUCCESS: {
      draft.isModalLoading = false;
      draft.memberModal = null;
      draft.memberItem = null;
      break;
    }

    case dlistsActions.UPSERT_MEMBER_FAILED: {
      draft.isModalLoading = false;
      draft.modalErrorMessage = action.payload;
      break;
    }

    case dlistsActions.CLOSE_MEMBER_MODAL: {
      draft.memberModal = null;
      draft.memberItem = null;
      draft.modalErrorMessage = null;
      break;
    }

    case dlistsActions.SELECT_SINGLE: {
      const payload = action.payload;
      if (payload.isSelected) {
        draft.members.selected.byId[payload.value] = true;
        draft.members.selected?.allIds?.push(payload.value);
      } else {
        draft.members.selected.byId[payload.value] = false;
        draft.members.selected.allIds = draft.members.selected?.allIds?.filter(
          value => value !== payload.value
        );
      }
      break;
    }

    case dlistsActions.SELECT_ALL: {
      const payload = action.payload;
      const byId = action.payload.list.reduce((obj, value) => {
        obj[value] = true;
        return obj;
      }, {});
      if (payload.isSelected) {
        draft.members.selected.byId = byId;
        draft.members.selected.allIds = [...action.payload.list];
      } else {
        draft.members.selected.byId = {};
        draft.members.selected.allIds = [];
      }
      break;
    }

    case dlistsActions.CLEAR_ERROR: {
      draft.errorMessage = null;
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
